/**
 * Estado do login entre telas (`/entrar` → `/entrar/codigo`): o desafio do 2FA e para onde voltar.
 * Só em memória: recarregar a página pede a senha de novo.
 */
import type { Id, SessionInfo } from '@rota/contracts';
import { safeReturnPath } from '../suite/areaRegistry';

let pending: { challengeId: Id; volta: string | null } | null = null;

export function setChallenge(challengeId: Id, volta: string | null): void {
  pending = { challengeId, volta };
}

export function takeChallenge(): { challengeId: Id; volta: string | null } | null {
  return pending;
}

export function clearChallenge(): void {
  pending = null;
}

/** Para onde ir depois de entrar: o `volta` seguro ou a tela inicial da pessoa (2.5). */
export function destinationAfterLogin(s: SessionInfo, volta: string | null): string {
  const v = safeReturnPath(volta);
  if (v) {
    const area = v.split('/')[1];
    const blocked =
      (area === 'painel' || area === 'automacoes' || area === 'estudio' || area === 'palco') &&
      !s.areas.includes(area as 'painel');
    if (!blocked) return v;
  }
  return s.home === '/' && s.areas.length < 2 ? `/${s.areas[0] ?? 'painel'}` : s.home;
}

/** Lê e apaga o fragmento `#t=<token>` (convite e redefinição): o token não fica no histórico. */
export function takeFragmentToken(): string | null {
  if (typeof location === 'undefined') return null;
  const m = /[#&]t=([A-Za-z0-9_-]+)/.exec(location.hash);
  if (m?.[1]) {
    try {
      history.replaceState(history.state, '', location.pathname + location.search);
    } catch {
      // sem History API: o fragmento fica, sem prejuízo
    }
  }
  return m?.[1] ?? null;
}
